<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <defs>
      <path id="a" d="M.25.125h.125V.25H.25z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(0 99.667)">
        <mask id="b" fill="#fff">
          <use xlink:href="#a" />
        </mask>
      </g>
      <path
        :fill="iconColor"
        d="M49.372 64.884c.4-.313.6-.749.6-1.307 0-.558-.196-.99-.587-1.294-.392-.305-.927-.457-1.607-.457H44.74v3.527h3.037c.663 0 1.194-.156 1.594-.47"
      />
      <path
        :fill="iconColor"
        d="M40.148 75.73V57.97h7.961c2.007 0 3.59.516 4.746 1.547 1.174 1.032 1.761 2.369 1.761 4.01 0 1.64-.587 2.985-1.76 4.033-1.158 1.032-2.74 1.548-4.747 1.548h-3.368v6.622h-4.593zm-8.115-17.76h4.593v17.76h-4.593V57.97zm-17.225 4.008V57.97h14.367v3.222l-8.498 10.53h8.906v4.008H14.476v-3.248L23 61.978h-8.19zM71.23 93.326H16.204c-2.281 0-4.14-1.847-4.14-4.118v-4.762h51.297c2.379 0 4.306-1.915 4.306-4.28V54.198c0-2.366-1.927-4.282-4.306-4.282H12.065V10.625c0-2.265 1.858-4.112 4.14-4.112l16.663-.017V8.71H27.61v3.486h5.26v3.486h-5.26v3.486h5.26v1.743h-1.754c-.804 0-1.506.544-1.7 1.32l-3.626 14.419a6.942 6.942 0 0 0 1.276 5.981 7.028 7.028 0 0 0 5.527 2.681h4.059c2.159 0 4.198-.989 5.527-2.68a6.942 6.942 0 0 0 1.275-5.982l-3.625-14.419a1.751 1.751 0 0 0-1.7-1.32h-1.754v-5.23h5.26v-3.485h-5.26V8.711h5.26V6.487l12.45-.013v13.922c0 4.067 3.318 7.369 7.41 7.369l13.716-.04.155 61.483c0 2.271-1.854 4.118-4.136 4.118zM35.963 33.378a3.486 3.486 0 0 1 2.164 3.22c0 1.926-1.57 3.487-3.506 3.487a3.507 3.507 0 0 1-3.239-2.152 3.472 3.472 0 0 1 .76-3.8 3.521 3.521 0 0 1 3.821-.755zM56.533 0H16.204C10.313 0 5.517 4.771 5.517 10.625v39.292H4.474c-2.379 0-4.307 1.916-4.307 4.282v25.966c0 2.366 1.928 4.281 4.307 4.281h1.043v4.762c0 5.861 4.796 10.626 10.687 10.626H71.23c5.89 0 10.685-4.765 10.685-10.626v-64.06L56.533 0z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-zip',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
